module.exports = __webpack_public_path__ + "static/media/visita_jogo_top_banner.aa87541c.webp";